export const getShortFileName = (fileName: string) => {
  if (fileName.length < 40) return fileName;

  return `${fileName.substring(0, 15)}...${fileName.substring(fileName.length - 15)}`;
};
